import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Internal email routes (/lovable/*) and the public one-click unsubscribe API
// must bypass app middleware (redirects, HTML error wrapping) so machine
// callers always get the raw JSON response.
const emailRouteBypass = createMiddleware().server(
  async ({ next, request }) => {
    const url = new URL(request.url);
    if (
      url.pathname.startsWith("/lovable/") ||
      url.pathname === "/email/unsubscribe"
    ) {
      return next();
    }
    return next();
  },
);

export const startInstance = createStart(() => ({
  // No server functions currently use `requireSupabaseAuth`. Importing
  // `attachSupabaseAuth` here pulls the entire `@supabase/supabase-js`
  // client (~600 kB) into the initial main bundle for every visitor, so
  // we deliberately leave `functionMiddleware` empty. Re-add it only when
  // a protected server function is introduced.
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [emailRouteBypass, errorMiddleware],
}));
